module.exports = __webpack_public_path__ + "img/dengage-logo.9b9bad90.svg";